
const state = {
  settings: {}
};

const getters = {
  getSettings: (state) => state.settings
};

const mutations = {
  SET_SETTINGS: (state, payload) => {
    state.settings = payload;
  }
};

const actions = {
  setSettings: ({ commit }, payload) => commit('SET_SETTINGS', payload)
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
